// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grey-divider-horizontal {
  height: 2px;
  background: #d9d9d9;
  width: 100%;
  margin: 40px 0px;
}

.num-spins-header {
  text-align: center;
  margin-bottom: 25px !important;
}

.game-tile-row {
  justify-content: center;
}

.bonus-game-col {
  display: inline-block;
  overflow: hidden;
}
.bonus-game-col .bonus-game-tile.single-game {
  margin-right: 0px;
}
.bonus-game-col .bonus-game-tile {
  margin-bottom: 20px;
}
@media screen and (min-width: 576px) {
  .bonus-game-col .bonus-game-tile {
    margin-right: 20px;
  }
}
.bonus-game-col .bonus-game-tile .game-tile-placeholder {
  padding: 10px;
  overflow: hidden;
  position: relative;
}
.bonus-game-col .bonus-game-tile .game-tile-placeholder .game-tile {
  width: 100%;
  padding-top: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  transition: all 0.7s;
  margin: auto;
}
@media screen and (min-width: 331px) and (max-width: 576px) {
  .bonus-game-col .bonus-game-tile .game-tile-placeholder .game-tile {
    height: 300px;
    width: 300px;
    padding-top: 0px;
    background-size: cover;
  }
}
.bonus-game-col .bonus-game-tile .spin-button {
  width: 100%;
  margin-top: 15px;
  margin-bottom: 15px;
  max-width: 274px;
  padding-left: 10px;
  padding-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/games-bonus-free-spins/games-bonus-free-spins.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AACA;EACE,kBAAA;EACA,8BAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AACA;EACE,qBAAA;EACA,gBAAA;AAEF;AADE;EACK,iBAAA;AAGP;AADE;EAIE,mBAAA;AAAJ;AAHI;EADF;IAEI,kBAAA;EAMJ;AACF;AAJI;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AAMN;AALM;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EAIA,oBAAA;EACA,YAAA;AAOR;AANQ;EAXF;IAYI,aAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;EASR;AACF;AANI;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAQN","sourcesContent":[".grey-divider-horizontal {\r\n  height: 2px;\r\n  background: #d9d9d9;\r\n  width: 100%;\r\n  margin: 40px 0px;\r\n}\r\n.num-spins-header {\r\n  text-align: center;\r\n  margin-bottom: 25px !important;\r\n}\r\n\r\n.game-tile-row {\r\n  justify-content: center\r\n}\r\n\r\n.bonus-game-col {\r\n  display: inline-block;\r\n  overflow: hidden;\r\n  .bonus-game-tile.single-game {\r\n       margin-right: 0px;\r\n  }\r\n  .bonus-game-tile {\r\n    @media screen and (min-width:576px) {\r\n      margin-right: 20px;\r\n    }\r\n    margin-bottom: 20px;\r\n    .game-tile-placeholder {\r\n      padding: 10px;\r\n      overflow: hidden;\r\n      position: relative;\r\n      .game-tile {\r\n        width: 100%;\r\n        padding-top: 100%;\r\n        background-size: cover;\r\n        background-repeat: no-repeat;\r\n        background-position: center;\r\n        -webkit-transition: all 0.7s;\r\n        -moz-transition: all 0.7s;\r\n        -o-transition: all 0.7s;\r\n        transition: all 0.7s;\r\n        margin: auto;\r\n        @media screen and (min-width: 331px )and (max-width:576px) {\r\n          height: 300px;\r\n          width: 300px;\r\n          padding-top: 0px;\r\n          background-size: cover;          \r\n        }\r\n      }\r\n    }\r\n    .spin-button {\r\n      width: 100%;\r\n      margin-top: 15px;\r\n      margin-bottom: 15px;\r\n      max-width: 274px;\r\n      padding-left: 10px;\r\n      padding-right: 10px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
